import { IonPage } from '@ionic/react';
import { IState, useAppSelector } from 'appRedux/createStore';
import CasinoNavBar from 'components/CasinoNavBar';

import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { InsightPopUp } from 'components/InsightsPopup/InsightsPopup';
import FooterLogo from 'components/FooterLogo';
import useWhiteLabelStyles, { WHITE_LABEL_TYPE_ENUM } from 'hooks/useWhiteLabelStyles';
import MapStats from './views/MapStats';
import AppTour from 'components/AppTour/AppTour';
import { OnboardingTourSteps } from 'components/AppTour/tours';
import { AuthService } from 'services/auth';
import { featureFlags } from 'config/featureFlags';
import { take, tap } from 'rxjs';
import { ReduxCommandCreator } from 'appRedux/actions';
import { useHistory } from 'react-router';
import RumTracker, { RumPageIdEnum } from 'components/RumAnalytics';
import LoginCasinoRevealHost from 'components/RandomOutcomesDrawer';
import LinkPlayerDrawerHost from 'components/LinkPlayerDrawer';
import { ensureRotateLandscapeMessage } from 'lib/ensureUserMessage';

export const Home = () => {
  const authService = new AuthService();
  const dispatch = useDispatch();
  const history = useHistory();
  const userInfo = useAppSelector((state) => state.app.persistedState.userInfo);

  const isLandscape = useAppSelector(
    (state) => state.app.persistedState.orientationState?.isOnlyPortrait
  );
  const isLandscapeOnly = useSelector<IState>(
    (state) => state.app.persistedState.orientationState?.isLandscape
  ) as boolean;
  const { isComparing } = useAppSelector((state) => state.app.persistedState.compareSlotsState);
  const hasCompletedOnboarding = useAppSelector(
    (state) => state.app.persistedState.userInfo?.hasCompletedOnboarding
  );
  const casinoSchema = useAppSelector((state) => state.app.persistedState.casinoSchema);
  const challengeHeaderBgUrl = useAppSelector((s: IState) => s.app.persistedState.slotState?.challengeHeaderBgUrl) ?? undefined;

  const [activeInsight, setActiveInsight] = useState('');
  const [showIonModal, setShowIonModal] = useState(false);
  const styles = useWhiteLabelStyles(WHITE_LABEL_TYPE_ENUM.CANVAS);

  const commands = ReduxCommandCreator(dispatch);
  const isExploreV2 = featureFlags.getThemeVersion() !== 'v1';

  const onTourClose = () => {
    authService
      .UpdateMe({ hasCompletedOnboarding: true })
      .pipe(
        take(1),
        tap((res) => {
          if (res?.userInfo) {
            commands.SetTourState(true);
          }
        })
      )
      .subscribe();
  };

  // Ensure the rotate-landscape user message exists for this user + casino
  // (server-side create-if-not-exists). Once per user + casino per tab session,
  // and shared with MapStats, which waits for it before GetUserMessages so the
  // first visit doesn't race the create. See lib/ensureUserMessage.
  useEffect(() => {
    const casinoId = casinoSchema?.casinoId;
    if (!casinoId) return;
    const sub = ensureRotateLandscapeMessage(
      authService,
      userInfo?.appUserPk,
      casinoId
    ).subscribe();
    return () => sub.unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [casinoSchema?.casinoId, userInfo?.appUserPk]);

  return (
    <IonPage
      className={`report-parent ${isExploreV2 ? 'theme-v2' : 'theme-v1'}`}
      style={{ overscrollBehaviorY: 'contain', WebkitOverflowScrolling: 'touch' }}
    >
      <RumTracker
        pageId={RumPageIdEnum.Home}
        pageAttributes={{ casinoID: casinoSchema?.casinoId as number }}
      />
      {showIonModal && (
        <InsightPopUp
          isOpen={showIonModal}
          activeInsight={activeInsight}
          setShowIonModal={() => {
            setShowIonModal(false);
          }}
        />
      )}
      {(!isComparing || !isLandscapeOnly) && (
        <CasinoNavBar headerBackgroundUrl={challengeHeaderBgUrl} />
      )}
      <div className="content content--home">
        <div className="container">
          {casinoSchema?.casinoId && (
            <AppTour
              steps={OnboardingTourSteps}
              onTourClose={onTourClose}
              showSkipButton
              hasCompletedOnboarding={hasCompletedOnboarding}
            />
          )}
          <MapStats />
          {/* </>
          )} */}
        </div>
        <FooterLogo />
      </div>
      {/* Random Outcomes as a locked drawer, once per login session on the first casino
          entry (login reopen or first pick). Renders nothing on later entries. */}
      <LoginCasinoRevealHost />
      {/* LinkPlayerflowVersion 2: Link Player ID in a drawer below the casino header, once
          per casino entry, after Random Outcomes. Renders nothing at Version 1 casinos. */}
      <LinkPlayerDrawerHost />
    </IonPage>
  );
};
